const MeetingTypes = Object.freeze({
  All: 0,
  Internal: 1,
  External: 2,
  Recurring: 4,
  Unique: 8,
});

export default MeetingTypes;
